<template>
  <div class="flex justify-between my-6" :class="!item.reverse ? 'flex-col lg:flex-row-reverse ' : 'flex-col lg:flex-row'">
    <div v-if="item.img" class="mt-2 lg:w-[45%] rounded-t p-2 lg:p-0" :class="item.hasBackColor ? '' : 'bg-[#FAFAFA] lg:bg-white'">
      <NuxtImg 
        width="500"
        :src="item.img"
        class="w-full"
        :alt="item.title"
      />
    </div>
    <template v-if="!item.full">
      <div class=" rounded-b lg:rounded flex justify-center items-center lg:w-[45%] p-10" :class="item.hasBackColor ? '' : 'bg-[#FAFAFA]'">
        <div class="flex flex-col justify-start">
          <div class="font-bold mb-5 w-full text-center lg:text-right">
            {{ item.title }}
          </div>
          <div class="font-semibold w-full text-justify text-sm">
            {{ item.desc }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class=" rounded flex items-center w-full p-10" :class="item.hasBackColor ? '' : 'bg-[#FAFAFA]'">
        <div class="flex flex-col justify-start">
          <div class="font-bold mb-5 w-full ">
            {{ item.title }}
          </div>
          <div class="font-semibold w-full text-justify text-sm">
            {{ item.desc }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
defineProps({
  item: Object,
})
</script>